(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knr-trust-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = {
      section: '[data-knr-trust-carousel]',
      track: '[data-knr-trust-track]',
      slide: '[data-knr-trust-slide]',
      dot: '[data-knr-trust-dot]'
    };

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initCarousel = (section) => {
      if (section.dataset.knrTrustReady === 'true') return;

      const track = section.querySelector(selectors.track);
      const slides = Array.from(section.querySelectorAll(selectors.slide));
      const dots = Array.from(section.querySelectorAll(selectors.dot));

      if (!track || slides.length < 2) return;

      section.dataset.knrTrustReady = 'true';

      let activeIndex = 0;
      let autoplayTimer = null;
      let resumeTimer = null;
      let scrollTimer = null;

      const updateDots = (index) => {
        activeIndex = index;

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const goTo = (index, behavior = 'smooth') => {
        const normalizedIndex = (index + slides.length) % slides.length;
        const target = slides[normalizedIndex];

        if (!target) return;

        track.scrollTo({
          left: target.offsetLeft,
          behavior
        });

        updateDots(normalizedIndex);
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (!mobileQuery.matches || reducedMotionQuery.matches || document.hidden) return;

        autoplayTimer = window.setInterval(() => {
          goTo(activeIndex + 1);
        }, 4000);
      };

      const pauseThenResume = () => {
        stopAutoplay();
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(startAutoplay, 7000);
      };

      const syncFromScroll = () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const slideWidth = track.clientWidth || 1;
          const index = Math.round(track.scrollLeft / slideWidth);
          updateDots(Math.max(0, Math.min(index, slides.length - 1)));
        }, 80);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.knrTrustDot));
          pauseThenResume();
        });
      });

      track.addEventListener('scroll', syncFromScroll, { passive: true });
      track.addEventListener('pointerdown', pauseThenResume, { passive: true });
      track.addEventListener('touchstart', pauseThenResume, { passive: true });
      section.addEventListener('focusin', pauseThenResume);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      mobileQuery.addEventListener('change', () => {
        if (mobileQuery.matches) {
          goTo(0, 'auto');
          startAutoplay();
        } else {
          stopAutoplay();
          track.scrollTo({ left: 0, behavior: 'auto' });
          updateDots(0);
        }
      });

      startAutoplay();
    };

    const initAll = (root = document) => {
      if (root.matches && root.matches(selectors.section)) {
        initCarousel(root);
      }

      root.querySelectorAll(selectors.section).forEach(initCarousel);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knr_premium_slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-slider')) {
    class PremiumSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.viewport = this.querySelector('[data-slider-viewport]');
        this.track = this.querySelector('[data-slider-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.previousButton = this.querySelector('[data-slider-previous]');
        this.nextButton = this.querySelector('[data-slider-next]');
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
        this.status = this.querySelector('[data-slider-status]');
        this.currentIndex = 0;
        this.touchStartX = null;
        this.touchStartY = null;
        this.autoplayTimer = null;
        this.isAutoplayPaused = false;
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.autoplaySpeed = Number.parseInt(this.dataset.autoplaySpeed || '5000', 10);
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.track || this.slides.length === 0) return;

        this.handlePrevious = () => this.goTo(this.currentIndex - 1);
        this.handleNext = () => this.goTo(this.currentIndex + 1);
        this.handleKeydown = (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.handlePrevious();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.handleNext();
          }
        };
        this.handleTouchStart = (event) => {
          const touch = event.changedTouches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.pauseAutoplay();
        };
        this.handleTouchEnd = (event) => {
          if (this.touchStartX === null || this.touchStartY === null) return;

          const touch = event.changedTouches[0];
          const differenceX = touch.clientX - this.touchStartX;
          const differenceY = touch.clientY - this.touchStartY;
          const isHorizontalSwipe = Math.abs(differenceX) > Math.abs(differenceY);

          if (isHorizontalSwipe && Math.abs(differenceX) > 50) {
            if (differenceX > 0) {
              this.handlePrevious();
            } else {
              this.handleNext();
            }
          }

          this.touchStartX = null;
          this.touchStartY = null;
          this.resumeAutoplay();
        };
        this.handleBlockSelect = (event) => {
          const selectedSlide = event.target.closest('[data-slide]');

          if (!selectedSlide || !this.contains(selectedSlide)) return;

          const selectedIndex = this.slides.indexOf(selectedSlide);
          if (selectedIndex >= 0) this.goTo(selectedIndex, false);
          this.pauseAutoplay(true);
        };
        this.handleBlockDeselect = () => this.resumeAutoplay(true);
        this.handlePointerEnter = () => this.pauseAutoplay();
        this.handlePointerLeave = () => this.resumeAutoplay();
        this.handleFocusIn = () => this.pauseAutoplay();
        this.handleFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.resumeAutoplay();
        };
        this.handleVisibilityChange = () => {
          if (document.hidden) {
            this.pauseAutoplay();
          } else {
            this.resumeAutoplay();
          }
        };
        this.handleReducedMotionChange = () => {
          if (this.reducedMotionQuery.matches) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.viewport?.addEventListener('keydown', this.handleKeydown);
        this.viewport?.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        this.viewport?.addEventListener('touchend', this.handleTouchEnd, { passive: true });
        this.addEventListener('mouseenter', this.handlePointerEnter);
        this.addEventListener('mouseleave', this.handlePointerLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        if (typeof this.reducedMotionQuery.addEventListener === 'function') {
          this.reducedMotionQuery.addEventListener('change', this.handleReducedMotionChange);
        } else if (typeof this.reducedMotionQuery.addListener === 'function') {
          this.reducedMotionQuery.addListener(this.handleReducedMotionChange);
        }

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const slideIndex = Number.parseInt(dot.dataset.slideIndex, 10);
            if (!Number.isNaN(slideIndex)) this.goTo(slideIndex);
          });
        });

        this.goTo(0, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.viewport?.removeEventListener('touchstart', this.handleTouchStart);
        this.viewport?.removeEventListener('touchend', this.handleTouchEnd);
        this.removeEventListener('mouseenter', this.handlePointerEnter);
        this.removeEventListener('mouseleave', this.handlePointerLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);

        if (this.reducedMotionQuery) {
          if (typeof this.reducedMotionQuery.removeEventListener === 'function') {
            this.reducedMotionQuery.removeEventListener('change', this.handleReducedMotionChange);
          } else if (typeof this.reducedMotionQuery.removeListener === 'function') {
            this.reducedMotionQuery.removeListener(this.handleReducedMotionChange);
          }
        }
      }

      startAutoplay() {
        this.stopAutoplay();

        if (
          !this.autoplayEnabled ||
          this.isAutoplayPaused ||
          this.reducedMotionQuery?.matches ||
          document.hidden ||
          this.slides.length < 2
        ) {
          return;
        }

        this.autoplayTimer = window.setInterval(() => {
          this.goTo(this.currentIndex + 1);
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      pauseAutoplay(force = false) {
        if (force) this.isAutoplayPaused = true;
        this.stopAutoplay();
      }

      resumeAutoplay(force = false) {
        if (force) this.isAutoplayPaused = false;
        if (!this.isAutoplayPaused) this.startAutoplay();
      }

      goTo(index, animate = true) {
        const totalSlides = this.slides.length;
        if (totalSlides === 0) return;

        this.currentIndex = (index + totalSlides) % totalSlides;

        if (!animate) this.track.classList.add('is-instant');
        this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.currentIndex;
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.toggleAttribute('inert', !isActive);
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (this.status) {
          const slideLabel = this.dataset.slideLabel || 'Slide';
          this.status.textContent = `${slideLabel} ${this.currentIndex + 1} / ${totalSlides}`;
        }

        if (!animate) {
          requestAnimationFrame(() => this.track.classList.remove('is-instant'));
        }

        if (this.autoplayEnabled && !this.isAutoplayPaused) {
          this.startAutoplay();
        }
      }
    }

    customElements.define('premium-slider', PremiumSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
